import type { Car } from '@/types/Car';

/**
 * Build a normalized version of the car's full year/make/model/trim.
 */
export function buildCarTitle(car: Car, includeTrim = true) {
  return [car?.year, car?.make, car?.model, includeTrim ? car?.trim : null]
    .filter(Boolean)
    .join(' ');
}
